<template>
    <div class="questbox">
        <button class="annihas" @click="xinzha">新增</button>
        <div class="tablelist">
            <el-table ref="filterTable" :data="tableData" :row-class-name="tableRowClassName" v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
                style="width: 100%;">

                <el-table-column label="标题" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.title }}
                    </template>
                </el-table-column>

                <el-table-column label="提问教师" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.teacher.name }}
                    </template>
                </el-table-column>
                <el-table-column label="问题描述" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.content }}
                    </template>
                </el-table-column>
                <el-table-column label="所属实验" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.learn.name }}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.created_at }}
                    </template>
                </el-table-column>
                <el-table-column label="修改时间" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.updated_at }}
                    </template>
                </el-table-column>
                <!-- <el-table-column label="操作"  align="center">
              <template slot-scope="scope" >
                <a size="mini" style="color:#1fb2e5;cursor:pointer;" @click="handleEdit(scope.$index, scope.row)" v-if="scope.row.total_score>=0">查看
                </a>
                <a size="mini" style="color:#393a43;cursor:pointer;"  v-else>查看
                </a>
              </template>
            </el-table-column> -->
            </el-table>
        </div>
        <el-dialog title="新增" :visible.sync="dialogFormVisible" width="30%">
            <el-form :model="form">
                <el-form-item label="标题" >
                    <input v-model="form.title" style="width:250px;height: 30px;margin-top: 5px;margin-left: 29px;">
                </el-form-item>
                <el-form-item label="提问教师">
                    <select v-model="form.teacher_id" style="width:250px;height: 30px;margin-top: 5px;"
                        placeholder="请选择提问教师">
                        <option v-for="item in chersList" :key="item.id" :label="item.name" :value="item.id"></option>
                    </select>
                </el-form-item>
                <el-form-item label="所属实验">
                    <select v-model="form.learn_id" style="width:250px;height: 30px;margin-top: 5px;"
                        placeholder="请选择所属实验">
                        <option v-for="item in learnmenulist" :key="item.id" :label="item.name" :value="item.id">
                        </option>
                    </select>
                </el-form-item>
                <el-form-item label="问题描述">
                    <el-input type="textarea" :rows="2" style="width:250px;height: 30px;margin-top: 5px;"
                        placeholder="请输入问题描述" v-model="form.content"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <button style=" width: 80px; height: 30px;position: absolute;bottom: 20px;right: 380px;" @click="dialogFormVisible = false">取 消</button>
                <button style=" width: 80px; height: 30px;position: absolute;bottom: 20px;right: 130px;" type="primary" @click="tijaofrom">确 定</button>
            </div>
        </el-dialog>
        <div style="margin-top:110px">
            <div class="bottomtion111">
                <el-pagination background @current-change="pageCurrentChange" :pager-count="pageform.countPage"
                    :page-count="pageform.pages" :current-page="pageform.pageNum" layout="prev, pager, next"
                    :total="pageform.total" :page-size='8'>
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading : true,
            textarea: '',
            chersList: '',
            learnmenulist: '',
            params: {
                page_size: 9999,
                page: 1,
            },
            tableData: [],
            pageform: {
                total: null,
                pages: null,  // 总页数
                pageNum: 1, // 当前的页码
                pageSize: 8, // 每页显示条目个数
                countPage: 3
            },
            params2: {
                // class_id: this.$store.getters.getUserInfo.class_id,
                page_size: 8,
                current_page: 1,
                user_id: this.$store.getters.getUserInfo.id,
                category_id: ''
            },
            dialogFormVisible: false,
            form: {
                title: '',
                teacher_id: '',
                content: '',
                learn_id: ''
            },
        }

    },
    created() {
        this.toplistmenu()
        this.getCourseList()
        this.gettopicteachersList()
    },
    methods: {
        tijaofrom(){
            this.form = []
            console.log(this.form)
            this.$http.topiaddList(this.form)
            .then(res=>{
                console.log(res)
                this.dialogFormVisible = false
                this.toplistmenu()
            })
        },
        getCourseList() {
            this.$http.courseList(this.params)
                .then(res => {
                    console.log(res)
                    this.learnmenulist = res.data.learn
                })
        },
        gettopicteachersList() {
            this.$http.topicteachersList(this.params)
                .then(res => {
                    console.log(res)
                    this.chersList = res.data
                })
        },
        xinzha() {
            this.dialogFormVisible = true
        },
        pageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
            console.log(val)
            this.pageform.pageNum = val;
            // console.log(this.pageform.pageNum)
            this.params2.page = val;
            this.toplistmenu()
        },
        onPracticeChange(learn_id) {
            this.params2.learn_id = learn_id;
            this.params2.page = 1;
            this.pageform.pageNum = 1;
            this.getScore();
        },
        toplistmenu() {
            console.log(this.params2)
            this.$http.topicList(this.params2).then(res => {
                console.log(res)
                this.loading = false;
                this.tableData = res.data.data
                this.pageform.pages = res.data.per_page;
                this.pageform.total = res.data.total;
            })

        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex === 0) {
                return 'warning-row';
            } else if (rowIndex === 1) {
                return 'success-row';
            } else if (rowIndex === 2) {
                return 'warning-row';
            } else if (rowIndex === 3) {
                return 'success-row';
            } else if (rowIndex === 4) {
                return 'warning-row';
            } else if (rowIndex === 5) {
                return 'success-row';
            } else if (rowIndex === 6) {
                return 'warning-row';
            } else if (rowIndex === 7) {
                return 'success-row';
            } else if (rowIndex === 8) {
                return 'warning-row';
            } else if (rowIndex === 9) {
                return 'success-row';
            }
            return '';
        },
    }

}
</script>

<style lang="less">
.questbox {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #212129;

    .tablelist {
        width: 1216px;
        min-height: 604px;
        margin:100px auto;
        overflow: hidden;
        // position: absolute;
        // top: 10px;

        .el-table .warning-row {
            background: #24252c;
            color: rgb(203, 200, 200);
        }

        .el-table .success-row {
            background: #2a2b32;
            color: rgb(203, 200, 200);
        }
    }

    .annihas {
        width: 80px;
        height: 30px;
        border-radius: 20px;
        position: absolute;
        top: 50px;
        left: 370px;
    }

    .bottomtion111 {
        height: 65px;
        width: 100%;
        background-color: #2f3037;
        //  margin-top: 20px;
        position: absolute;
        bottom: 0;
        // z-index: 1000;
        display: flex;
        justify-content: center;
    }

    .el-pagination {
        margin: auto;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/User/Questionon.vue